module.exports = __webpack_public_path__ + "static/img/SMART.7ef3004.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/SMART.png
// module id = ynj6
// module chunks = 1